import SendShiftHost from '../../components/report/sendShiftHost'

export default {
  components: {
    SendShiftHost
  },
  data () {
    return {
      bt_type: 0
    }
  },
  methods: {
    goToPage (path) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push(path)
    },
    doing () {
      alert('รอดำเนินการ')
    },
    Modal (type) {
      this.bt_type = type
      $('#ModalReport').modal('show')
    }
  },
  mounted () {
    this.$store.state.historyPage = ''
    this.checkUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/main_report.js